import { defineStyleConfig } from '@chakra-ui/system';

export const Icon = defineStyleConfig({
    baseStyle: {
        display: 'inline-block',
        verticalAlign: 'bottom',
        boxSize: 4,
    },
});
